// import { theme } from "antd";

const defaultThemeToken = {
  //  SeedToken
  colorPrimary: "#384cc0", // 品牌色是体现产品特性和传播理念最直观的视觉元素之一。在你完成品牌主色的选取之后，我们会自动帮你生成一套完整的色板，并赋予它们有效的设计语义
  colorInfo: "#384cc0", // 用于表示操作信息的 Token 序列，如 Alert 、Tag、 Progress 等组件都有用到该组梯度变量。
  colorSuccess: "#0aceac", // 用于表示操作成功的 Token 序列，如 Result、Progress 等组件会使用该组梯度变量。
  colorWarning: "#fab630", // 用于表示操作警告的 Token 序列，如 Notification、 Alert等警告类组件或 Input 输入类等组件会使用该组梯度变量。
  colorError: "#ec3e3e", // 用于表示操作失败的 Token 序列，如失败按钮、错误状态提示（Result）组件等。
  colorLink: "#284cc0", // 控制超链接的颜色。
  colorTextBase: "#333333", // 用于派生文本色梯度的基础变量，v5 中我们添加了一层文本色的派生算法可以产出梯度明确的文本色的梯度变量。但请不要在代码中直接使用该 Seed Token ！
  // colorBgBase: "#f6f7fc", // 用于派生背景色梯度的基础变量，v5 中我们添加了一层背景色的派生算法可以产出梯度明确的背景色的梯度变量。但请不要在代码中直接使用该 Seed Token ！

  fontSize: 12, // 设计系统中使用最广泛的字体大小，文本梯度也将基于该字号进行派生。
  // sizeStep: 4, // 用于控制组件尺寸的基础步长，尺寸步长结合尺寸变化单位，就可以派生各种尺寸梯度。通过调整步长即可得到不同的布局模式，例如 V5 紧凑模式下的尺寸步长为 2

  // MapToken
  // 文本色（会根据 colorTextBase 自动计算）, 覆盖的话使用rgba色, 否则会导致暗色模式错误
  // colorTextSecondary: "#666666", // 作为第二梯度的文本色，一般用在不那么需要强化文本颜色的场景，例如 Label 文本、Menu 的文本选中态等场景。
  // colorTextTertiary: "#999999", // 	第三级文本色一般用于描述性文本，例如表单的中的补充说明文本、列表的描述性文本等场景。
  // colorTextQuaternary: "#bfbfbf", // 第四级文本色是最浅的文本色，例如表单的输入提示文本、禁用色文本等。
  // 边框色
  // colorBorder: "#dbdde4", // 默认使用的边框颜色, 用于分割不同的元素，例如：表单的分割线、卡片的分割线等。
  // colorBorderSecondary: "#e7e8ed", // 比默认使用的边框色要浅一级，此颜色和 colorSplit 的颜色一致。使用的是实色。
  // 填充色, 需要RGBA色
  // colorFill: "#e9edf8", // 最深的填充色，用于拉开与二、三级填充色的区分度，目前只用在 Slider 的 hover 效果。
  // colorFillSecondary: "#eef1f7", // 二级填充色可以较为明显地勾勒出元素形体，如 Rate、Skeleton 等。也可以作为三级填充色的 Hover 状态，如 Table 等。
  // colorFillTertiary: "#f6f7fc", // 三级填充色用于勾勒出元素形体的场景，如 Slider、Segmented 等。如无强调需求的情况下，建议使用三级填色作为默认填色。
  // colorFillQuaternary: "#ffffff", // 最弱一级的填充色，适用于不易引起注意的色块，例如斑马纹、区分边界的色块等。
  // 背景色（会根据 colorBgBase 自动计算）
  // colorBgContainer: "#ffffff", // 组件的容器背景色，例如：默认按钮、输入框等。务必不要将其与 `colorBgElevated` 混淆。
  // colorBgElevated: "#ffffff", // 浮层容器背景色，在暗色模式下该 token 的色值会比 `colorBgContainer` 要亮一些。例如：模态框、弹出框、菜单等。
  // colorBgLayout: "#f6f7fc", // 该色用于页面整体布局的背景色，只有需要在页面中处于 B1 的视觉层级时才会使用该 token，其他用法都是错误的
  // colorBgSpotlight: "rgba(0,0,0,0.85)", // 	该色用于引起用户强烈关注注意的背景色，目前只用在 Tooltip 的背景色上。

  // // 主色（会根据 colorPrimary 自动计算）
  // colorPrimaryBg: "#e9edf8", // 主色浅色背景颜色，一般用于视觉层级较弱的选中状态。
  // colorPrimaryBgHover: "#d4dbf2", // 与主色浅色背景颜色相对应的悬浮态颜色。
  // colorPrimaryBorder: "#7e93d9", // 主色梯度下的描边用色，用在 Slider 等组件的描边上。
  // colorPrimaryBorderHover: "#536fcc", // 主色梯度下的描边用色的悬浮态，Slider 、Button 等组件的描边 Hover 时会使用。
  // colorPrimaryHover: "#536fcc", // 主色梯度下的悬浮态。
  // colorPrimaryActive: "#182d73", // 主色梯度下的深色激活态。
  // colorPrimaryTextHover: "#536fcc", // 主色梯度下的文本悬浮态。
  // colorPrimaryTextActive: "#182d73", // 主色梯度下的文本激活态。
  // // 成功色（会根据 colorSuccess 自动计算）
  // colorSuccessActive: "#075548", // 成功色的深色激活态
  // colorSuccessTextActive: "#075548", // 成功色的文本激活态
  // colorSuccessText: "#0da48a", // 成功色的文本默认态
  // colorSuccessHover: "#0da48a", // 成功色的深色悬浮态
  // colorSuccessBgHover: "#d6fcf5", // 成功色浅色背景颜色，一般用于视觉层级较弱的选中状态，不过 antd 目前没有使用到该 token
  // colorSuccessBg: "#d6fcf5", // 成功色的浅色背景颜色，用于 Tag 和 Alert 的成功态背景色
  // // 警告色（会根据 colorWarning 自动计算）
  // colorWarningActive: "#e19705", // 警戒色的深色激活态
  // colorWarningTextActive: "#e19705", // 警戒色的文本激活态
  // colorWarningBg: "#fef0d6", // 警戒色的浅色背景颜色
  // colorWarningBgHover: "#fef0d6", // 	警戒色的浅色背景色悬浮态
  // // 错误色（会根据 colorError 自动计算）
  // colorErrorActive: "#d11515", // 错误色的深色激活态
  // colorErrorTextActive: "#d11515", // 错误色的文本激活态
  // colorErrorBg: "#fbd9d9", // 错误色的浅色背景颜色
  // colorErrorBgHover: "#fbd9d9", // 错误色的浅色背景色悬浮态
  // // 链接色（会根据 colorLink 自动计算）
  // colorLinkHover: "#838792", // 控制超链接悬浮时的颜色。
  // colorLinkActive: "#203c99", // 控制超链接被点击时的颜色。
};

const defaultThemeComponents = {
  Table: {
    cellFontSize: 12,
    // fixedHeaderSortActiveBg: "rgb(238,241,247)",
    // footerBg: "rgb(246,247,252)",
    // footerColor: "rgb(51,51,51)",
    // headerBg: "rgb(238,241,247)",
    // headerColor: "rgb(51,51,51)",
    // headerSortActiveBg: "rgb(233,237,248)",
    // headerFilterHoverBg: "rgba(0,0,0,0.06)",
    // headerSortHoverBg: "rgb(224,228,239)",
    // headerSplitColor: "rgb(219,221,228)",
    // rowHoverBg: "rgb(238,241,247)",
    // rowSelectedBg: "rgb(233,237,248)",
    // rowSelectedHoverBg: "rgb(224,228,239)",
    // colorLinkHover: "rgb(32,60,153)",
    // colorText: "rgb(51,51,51)",
    // colorTextHeading: "rgb(26,26,26)",
    // controlItemBgHover: "rgb(238,241,247)",
    cellFontSizeMD: 12,
    cellFontSizeSM: 12,
    cellPaddingBlock: 8,
    cellPaddingBlockMD: 8,
    margin: 12,
    padding: 8,
    controlInteractiveSize: 16,
    // stickyScrollBarBg: "rgba(0,0,0,0.05)",
    headerBorderRadius: 4,
    borderRadius: 4,
  },
  // Button: {
  //   contentLineHeight: 1.5,
  //   contentLineHeightSM: 1.5,
  //   paddingBlock: 4,
  //   paddingBlockLG: 6,
  //   paddingBlockSM: 2,
  //   paddingInline: 12,
  //   paddingInlineLG: 16,
  //   paddingInlineSM: 8,
  //   defaultHoverBorderColor: "rgb(40,76,192)",
  //   defaultHoverColor: "rgb(40,76,192)",
  //   borderColorDisabled: "rgb(233,237,248)",
  //   defaultBorderColor: "rgb(207,210,219)",
  //   defaultColor: "rgb(51,51,51)",
  //   defaultGhostColor: "rgb(51,51,51)",
  //   groupBorderColor: "rgb(207,210,219)",
  //   linkHoverBg: "rgb(233,237,248)",
  //   textHoverBg: "rgb(233,237,248)",
  //   textTextActiveColor: "rgb(51,51,51)",
  //   textTextColor: "rgb(51,51,51)",
  //   textTextHoverColor: "rgb(51,51,51)",
  // },
  // Typography: {
  //   titleMarginBottom: "0.7em",
  //   titleMarginTop: "1.0em",
  //   lineHeight: 1.4,
  //   marginXXS: 4,
  //   lineHeightHeading1: 1.4,
  //   lineHeightHeading2: 1.4,
  // },
  // Popover: {
  //   colorBgElevated: "rgba(0,0,0,0.8)",
  //   colorText: "rgba(255,255,255,0.88)",
  //   colorTextHeading: "rgba(255,255,255,0.88)",
  // },
  // Layout: {
  //   headerBg: "rgb(255,255,255)",
  //   lightSiderBg: "rgb(246,247,252)",
  //   headerColor: "rgb(51,51,51)",
  //   siderBg: "rgb(246,247,252)",
  //   headerHeight: 56,
  //   lightTriggerColor: "rgba(0,0,0,0.8)",
  //   triggerBg: "rgba(0,33,64,0.8)",
  //   colorText: "rgb(51,51,51)",
  // },
  // Menu: {
  //   itemBg: "rgb(246,247,252)",
  //   itemColor: "rgb(51,51,51)",
  // },
  // Modal: {
  //   lineHeight: 1.4,
  // },
  // Notification: {
  //   lineHeight: 1.4,
  // },
  // DatePicker: {
  //   paddingInline: 11,
  //   paddingInlineSM: 11,
  //   paddingInlineLG: 11,
  //   paddingBlockLG: 9,
  //   paddingBlockSM: 9,
  //   paddingBlock: 5,
  // },
  Radio: {
    dotSize: 8,
    radioSize: 16,
  },
  Checkbox: {
    controlInteractiveSize: 16,
  },
  // Tooltip: {
  //   colorText: "rgba(0,0,0,0.88)",
  //   colorBgSpotlight: "rgba(0,0,0,0.85)",
  //   colorTextLightSolid: "rgb(255,255,255)",
  // },
};

// export const defaultThemeConfig = {
//   cssVar: true, // 开启 antd css 变量
//   token: {
//     colorPrimary: "#531dab",
//     ...defaultThemeToken,
//   },
//   components: defaultThemeComponents,
//   // algorithm: [theme.darkAlgorithm],
// };

/**
 * 根据appInfo.extend.theme 中的配置信息, 生成主题配置
 **/
export const generateThemeConfig = (appInfo) => {
  let colorPrimary = "default"; // 用户定义的品牌色
  let theme = null; // 用户定义的主题配置
  try {
    const { skinColor, themeConfig } = appInfo.extend;
    colorPrimary = skinColor;
    theme = JSON.parse(themeConfig);
  } catch (error) {}

  // 如果用户定义了品牌色, 则覆盖默认的主色
  if (colorPrimary && colorPrimary !== "default") {
    defaultThemeToken.colorPrimary = colorPrimary;
  }

  return {
    cssVar: true, // 重要, 必须开启 antd css 变量
    token: defaultThemeToken,
    components: defaultThemeComponents,
  };
};
